module.exports = __webpack_public_path__ + "static/media/021-sunset.47189161.svg";